import React from 'react';
import ReactDOM from 'react-dom';
import {apiFetch} from 'utilities/apiFetch';
import AModal from '../checkout/components/AModal';
import {
  APPLICATION_CALLBACK_URL,
  getCommUrl,
  getRedirectUrl,
  LOAD_STATE_FROM_CID,
  RESERVATION_CALLBACK_URL,
} from './corsTargets';

// Maximum number of seconds to show the user the modal
const processingModalTimeout = 90;

const handleCheckoutAsync = (hash, isAReservation) => {
  showProcessingModal(isAReservation);
  getStateOfApplicationEverySecond(hash, isAReservation);
};

const showProcessingModal = (isAReservation) => {
  ReactDOM.render(
    <AModal>
      <div className="a-spinner a-spinner-square"></div>
      {isAReservation()
        ?
        <div className="handle-checkout-async__format">Ihre Reservierung wird
          bearbeitet</div>
        :
        <div className="handle-checkout-async__format">Ihr Vertrag wird
          bearbeitet<br/>(Dies kann bis zu 2 Minuten dauern)</div>}
    </AModal>, document.getElementById('modalAnchor'));
};

const redirectTo = (
  state,
  isReservationActive,
  hash,
  orderId = null,
  pramie = null,
  digital,
) => {
  const query = {
    cid: hash,
    pramie: pramie,
    vertragsnr: orderId,
    version: '2',
    digital: digital,
  };

  switch (state) {
    case 'accepted':
      query.is_accepted = true;
      break;
    case 'declined':
      query.is_accepted = false;
      break;
    default: // pending or something went wrong
      query.is_accepted = false;
      query.is_pending = true;
      break;
  }

  const callbackBaseUrl = isReservationActive() ?
    RESERVATION_CALLBACK_URL :
    APPLICATION_CALLBACK_URL;
  const url = getRedirectUrl(callbackBaseUrl, query);
  window.location.replace(url);
};

const getStateOfApplicationEverySecond = (hash, isAReservation) => {
  let count = 0;
  const interval = setInterval(() => {
    count++;

    getStateOfApplication(hash, isAReservation).
    then(({state, orderId, rate, digital}) => {
      // Execute if the state is anything but 'submitted' or 'created'.
      if (!(state == 'submitted' || state == 'created' || state == 'pending')
        || count > processingModalTimeout) {
        clearInterval(interval);
        redirectTo(state, isAReservation, hash, orderId, rate, digital);
      }
    });
  }, 1000);
};

const getStateOfApplication = async (hash, isReservationActive) => {
  const url = getCommUrl(LOAD_STATE_FROM_CID(isReservationActive())) +
    `/${hash}`;
  const {data} = await apiFetch(url);
  return {
    state: data.state,
    orderId: data.orderId,
    rate: data.rate,
    digital: data.digital || false,
  };
};

export {
  handleCheckoutAsync,
};
